import React from 'react';
import { FaCheckCircle } from 'react-icons/fa';
import ContactForm from './ContactForm';
import ContactDetails from './ContactDetails';
import PhoneCTA from './PhoneCTA';
import './CTA.css';

const ctaFeatures = [
  'Zero Hidden Fees',
  'Expert Fitment Check',
  '90-Day Ironclad Warranty',
  'Priority Expedited Shipping',
];

const CTA = () => {
  return (
    <section className="cta-section" id="contact">
      <div className="cta-container">
        <div className="cta-left">
          <div className="cta-badge">EXPERIENCE THE DIFFERENCE</div>
          <h2>Premium Auto Parts,<br />Without the Premium Price Tag.</h2>
          <p>
            Join thousands of satisfied drivers and mechanics who trust{' '}
            <strong className="highlight-text">MaxAutoParts</strong>
            for top-tier OEM and aftermarket parts. Skip the dealership markup and get direct
            access to our national inventory.
          </p>
          <div className="cta-features">
            {ctaFeatures.map((feat, i) => (
              <div className="cta-feat" key={i}>
                <div className="feat-icon-wrapper">
                  <FaCheckCircle className="cta-feat-icon" />
                </div>
                <span>{feat}</span>
              </div>
            ))}
          </div>
          <ContactDetails />
          <div className="cta-phone-wrap">
            <PhoneCTA variant="primary" />
          </div>
        </div>

        <div className="cta-right">
          <ContactForm />
        </div>
      </div>
    </section>
  );
};

export default CTA;
